import { useRequest } from 'ahooks';
import { useEffect } from 'react';
import { LeaseBasic, useReadyInfo } from '@/providers/ReadyProvider';
import { fetchLeaseBasic } from '@/services/site';

/**
 * 获取租赁下拉框数据
 * - pledge_type 质押方式
 * - item_type 租赁物品
 */
const useLeaseBasic = () => {
  const { leaseBasic, setLeaseBasic } = useReadyInfo();

  const { run: getLeaseBasic, data, loading } = useRequest(fetchLeaseBasic, { manual: true });

  useEffect(() => {
    if (!leaseBasic || !leaseBasic?.pledge_type || !leaseBasic?.item_type) {
      getLeaseBasic().then((res) =>
        setLeaseBasic({
          pledge_type:
            res?.pledge_type?.map((v) => {
              return { label: v.name, value: v.id };
            }) ?? [],
          item_type:
            res?.item_type?.map((v) => {
              return { label: v.name, value: v.id };
            }) ?? [],
        })
      );
    }
  }, [leaseBasic]);

  return {
    data:
      leaseBasic ||
      ({
        pledge_type:
          data?.pledge_type?.map((v) => {
            return { label: v.name, value: v.id };
          }) ?? [],
        item_type:
          data?.item_type?.map((v) => {
            return { label: v.name, value: v.id };
          }) ?? [],
      } as LeaseBasic),
    loading,
  };
};

export default useLeaseBasic;
